import {resetStoredData} from "@js/parts/search/functions/reset/resetStoredData";
import {updateTagsView} from "@js/parts/search/functions/searchfilterbox/updateTagsView";
import {determineSearchCount} from "@js/parts/search/functions/logic/determineSearchCount";
import { datalayer_triggerSearch } from "@js/globalFunctions/datalayerFunctions";
import {triggerCallbackAfterEventOrIfFired, triggerDocumentEvent} from "@js/globalFunctions/events";
import {pageHasMainSearchBlock} from "../../blocks/search/pageHasMainSearchBlock";
import {updateSearchCountDisplay} from "@js/parts/search/functions/updateSearchCountDisplay";
import {startSearchCountLoader, stopSearchCountLoader} from "@js/globalFunctions/loaders";


$(document).ready(function() {
	triggerCallbackAfterEventOrIfFired('pageIsReadyForSearch',function(){
		triggerDocumentEvent('searchChanged')
	});
	$(document).on('searchChanged',function(e){
		if(pageHasMainSearchBlock())
			return;

		resetStoredData();
		updateTagsView();
		startSearchCountLoader();
		$.ajax({
			url: $('.fullSearchSubmitBtnClass').data('url')+'?v2',
			type: 'GET',
			success:function(data){
				datalayer_triggerSearch(data);
				const searchCount = determineSearchCount(data);
				const currentCount = parseInt($('#searchCount').text());
				stopSearchCountLoader();
				updateSearchCountDisplay(searchCount,currentCount);
			}
		});
	});
});

